import { Injectable } from '@angular/core';
import { LibEventManagerService } from 'tuain-ng-forms-lib';

const eventTypes = {
  behaviour: 'behaviour',
  subject: 'subject',
  reply: 'reply',
};

const eventClasses = [
  { name: 'startApp', type: eventTypes.behaviour },
  { name: 'menuObtained', type: eventTypes.behaviour },
  { name: 'sessionObtained', type: eventTypes.behaviour },
  { name: 'sessionEstablished', type: eventTypes.behaviour },
  { name: 'sessionToBeClosed', type: eventTypes.subject },
  { name: 'formActivity', type: eventTypes.subject },
  { name: 'sessionEnded', type: eventTypes.subject },
  { name: 'notAuthorized', type: eventTypes.subject },
  { name: 'serverProcessStarted', type: eventTypes.subject },
  { name: 'serverProcessEnded', type: eventTypes.subject },
  { name: 'configLoaded', type: eventTypes.behaviour },
  { name: 'apiReady', type: eventTypes.subject },
  { name: 'notification', type: eventTypes.behaviour },
  { name: 'chat', type: eventTypes.behaviour },
  { name: 'chatMessage', type: eventTypes.behaviour },
  { name: 'messageRead', type: eventTypes.behaviour },
  { name: 'profileObtained', type: eventTypes.behaviour },
  { name: 'sessionSignKeyReceived', type: eventTypes.behaviour },
  { name: 'sessionEncryptKeyReceived', type: eventTypes.behaviour },
  { name: 'noSessionNext', type: eventTypes.behaviour },
  { name: 'updateLastActivityDate', type: eventTypes.subject },
  { name: 'pendingNotifications', type: eventTypes.behaviour },
];

@Injectable({ providedIn: 'root' })
export class EventManagerService extends LibEventManagerService {
  constructor() { super(eventClasses); }
}